import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CustomizedComponent } from './customized-section/customized-section.component';
import { TechnologiesComponent } from './technologies/technologies.component';
import { CostPlanCardComponent } from '../cost-plan/cost-plan-card/cost-plan-card.component';
import { ClientsSayComponent } from './clients-say/clients-say';
import { SolutionsComponent } from './solutions/solutions.component';
import { ReachOutSectionComponent } from './reach-out-section/reach-out-section.component';
import { ReasonsComponent } from './reasons/reasons.component';
import { WorkFlowSectionComponent } from './work-flow-section/work-flow-section.component';

@Component({
    selector: 'app-home',
    standalone: true,
    imports: [ButtonModule, CustomizedComponent, TechnologiesComponent, CostPlanCardComponent, ClientsSayComponent, SolutionsComponent, ReachOutSectionComponent, ReasonsComponent,
        WorkFlowSectionComponent],
    templateUrl: './home.component.html',
    styleUrl: './home.component.less',
})
export class HomeComponent {
    isHome: boolean = true;
}
